// grid helpers

import { GridColumn } from "@progress/kendo-react-grid";
export const renderColumns = (columns) => {
  return columns.map((col, index) => {
    if (col.children) {
      return (
        <GridColumn
          key={index}
          title={col.title}
          width={col.width}
        >
          {renderColumns(col.children)}
        </GridColumn>
      );
    }

    return (
      <GridColumn
        key={index}
        field={col.field}
        title={col.title}
        width={col.width}
        minResizableWidth={col.minWidth}
        resizable={col.resizable ?? true}
        headerCell={col.headerCell}
        cell={col.cell}
      />
    );
  });
};


// treelist helpers




//sidebar menu items

  export const menuItem = [ 
        {
            name:"Studies",
            path:"/studies",
            icon: <i className="fa fa-list"></i>,
            subPaths:[]
        },
        {
            name:"Few Shot Examples",
            path:"/shotexamples",
            icon:<i class="fa-solid fa-file-lines"></i>,
            subPaths:[]
        },
        {
            name:"Prompts",
            path:"/prompts",
            icon: <i class="fa-solid fa-robot"></i>,
            subPaths:[]
        },
        {
            name:"Pydantic Data Schema",
            path:"/pydanticDataSchema",
            icon: <i class="fa-solid fa-code"></i>,
            subPaths:[]
        },
        {
            name:"Domains",
            path:"/domains",
            icon: <i class="fa-solid fa-globe"></i>,
            subPaths:[]
        },
        {
            name:"Statistical Analysis Methods",
            path:"/StatisticalAnalysisMethods",
            icon:<i class="fa-solid fa-calculator"></i>,
            subPaths:[]
        },
     ]